import React from "react";
import Box from "@amzn/meridian/box";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import RosteredHeadcountDisplay from "../RosteredHeadcountDisplay/RosteredHeadcountDisplay";
import { RosterData, AvailableLabor } from "../../model";

interface RatesAndRosterHeaderProps {
    rosterData?: RosterData | null;
    planId: string | null;
    availableLabor?: AvailableLabor | null;
}

const RatesAndRosterHeader: React.FC<RatesAndRosterHeaderProps> = ({rosterData, planId, availableLabor}) => {
    return (
        <Box>
            <Row alignmentVertical="top" widths={["fit", "fill"]}>
                <Column>
                    <Heading type="h400" level={2}>
                        Roster and Rates
                    </Heading>
                    <Text>Verify values below or adjust attendance</Text>
                    {planId && <Text type="b300">Plan ID: {planId}</Text>}
                </Column>
                <Row alignmentHorizontal="center">
                    <RosteredHeadcountDisplay
                        labor={availableLabor}
                        legacyHeadcount={rosterData?.headcount}
                    />
                </Row>
            </Row>
        </Box>
    );
}

export default RatesAndRosterHeader;
